import i18n from 'i18n-js';
import * as types from './types';
import { uiActions } from 'state/modules/UI';
import * as accountStatementsAPI from '../../../services/api/accountStatement';
import { getErrorMessage, parsePagination, isCancel } from 'utils';

// Get Account Statements
const fetchAccountStatementsRequest = () => ({
  type: types.FETCH_ACCOUNT_STATEMENTS_REQUEST,
});

const fetchAccountStatementsSuccess = (payload) => ({
  type: types.FETCH_ACCOUNT_STATEMENTS_SUCCESS,
  payload,
});

const fetchAccountStatementsFailed = () => ({
  type: types.FETCH_ACCOUNT_STATEMENTS_FAILED,
});

export const fetchAccountStatements = (params, options) => {
  return async (dispatch) => {
    dispatch(fetchAccountStatementsRequest());

    let response;
    if (params?.account_statement_id && !isNaN(params?.account_statement_id)) {
      response = await accountStatementsAPI.fetchAccountStatementById(params?.account_statement_id);
      if (response.ok) {
        return dispatch(
          fetchAccountStatementsSuccess({
            pagination: {},
            data: [response.data],
          })
        );
      }
      return dispatch(fetchAccountStatementsFailed());
    } else {
      response = await accountStatementsAPI.fetchAccountStatements(params, options);
    }

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchAccountStatementsSuccess({
          pagination,
          data: response.data,
        })
      );
    }

    if (!isCancel(response)) {
      const formattedError = getErrorMessage(response?.data);

      dispatch(fetchAccountStatementsFailed({ errors: formattedError }));

      if (typeof formattedError === 'string') {
        return dispatch(
          uiActions.handleShowSnackbar({
            type: 'error',
            message: formattedError,
          })
        );
      }

      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError[0].message,
        })
      );
    }
  };
};

// Get Account Statement by ID
const fetchAccountStatementRequest = () => ({
  type: types.FETCH_ACCOUNT_STATEMENT_BY_ID_REQUEST,
});

const fetchAccountStatementSuccess = (payload) => ({
  type: types.FETCH_ACCOUNT_STATEMENT_BY_ID_SUCCESS,
  payload,
});

const fetchAccountStatementFailed = (error) => ({
  type: types.FETCH_ACCOUNT_STATEMENT_BY_ID_FAILED,
  error,
});

export const fetchAccountStatementById = (id) => {
  return async (dispatch) => {
    dispatch(fetchAccountStatementRequest());

    const response = await accountStatementsAPI.fetchAccountStatementById(id);

    if (response.ok) {
      return dispatch(fetchAccountStatementSuccess({ data: response.data }));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchAccountStatementFailed(error));
  };
};

// Process Balance in Account Statement by ID
const processBalanceAccountStatementRequest = () => ({
  type: types.PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_ID_REQUEST,
});

const processBalanceAccountStatementSuccess = () => ({
  type: types.PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_ID_SUCCESS,
});

const processBalanceAccountStatementFailed = (error) => ({
  type: types.PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_ID_FAILED,
  error,
});

export const processBalanceAccountStatementById = (id) => {
  return async (dispatch) => {
    dispatch(processBalanceAccountStatementRequest());

    const response = await accountStatementsAPI.processAccountStatementBalanceById(id);

    if (response.ok) {
      dispatch(processBalanceAccountStatementSuccess());
      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('account_statement.processing_balance_msg'),
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(processBalanceAccountStatementFailed(error));
  };
};

// Process Balance in Account Statement in Bulk
const processBalanceAccountStatementBulkRequest = () => ({
  type: types.PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_BULK_REQUEST,
});

const processBalanceAccountStatementBulkSuccess = () => ({
  type: types.PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_BULK_SUCCESS,
});

const processBalanceAccountStatementBulkFailed = (error) => ({
  type: types.PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_BULK_FAILED,
  error,
});

export const processBalanceAccountStatementBulk = (payload) => {
  return async (dispatch) => {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: i18n.t('common.background_process'),
      })
    );

    dispatch(processBalanceAccountStatementBulkRequest());

    const response = await accountStatementsAPI.processAccountStatementBalanceBulk(payload);

    if (response.ok) {
      return dispatch(processBalanceAccountStatementBulkSuccess({ data: response.data }));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(processBalanceAccountStatementBulkFailed(error));
  };
};
